import axios from 'axios';
import { opportunityJobLocationService } from '@/services/opportunity-job-location.service';

const initialState = () => ({
  status: {
    error: null,
    pending: false,
    pendingEdit: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  selectTenderDeliveryLocation({ commit }, { opportunityId }) {
    commit('EDIT_OPPORTUNITY_JOB_LOCATION');
    return opportunityJobLocationService.selectTenderDeliveryLocation({ opportunityId }).then(
      (opportunity) => {
        commit('opportunities/EDIT_OPPORTUNITY_SUCCESS', opportunity, { root: true });
        commit('opportunity/EDIT_OPPORTUNITY_SUCCESS', opportunity, { root: true });
        commit('EDIT_OPPORTUNITY_JOB_LOCATION_SUCCESS');
        return opportunity;
      },
      (error) => {
        commit('ERROR', error);
        throw error;
      },
    );
  },
  editOpportunityJobLocation({ commit }, { opportunityId, jobLocation }) {
    commit('EDIT_OPPORTUNITY_JOB_LOCATION');

    return opportunityJobLocationService.editOpportunityJobLocation({ opportunityId, jobLocation }).then(
      (opportunity) => {
        commit('opportunities/EDIT_OPPORTUNITY_SUCCESS', opportunity, { root: true });
        commit('opportunity/EDIT_OPPORTUNITY_SUCCESS', opportunity, { root: true });
        commit('EDIT_OPPORTUNITY_JOB_LOCATION_SUCCESS');
      },
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ERROR', error);
          throw error;
        }
      },
    );
  },
};

const mutations = {
  EDIT_OPPORTUNITY_JOB_LOCATION(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  EDIT_OPPORTUNITY_JOB_LOCATION_SUCCESS(state) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
};

const getters = {
  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const opportunityJobLocation = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
